// Back-to-top arrow: pops in after the shopper scrolls down about one screen, its ring fills with
// scroll progress, and on click the arrow launches upward while the page smooth-scrolls to the top.
// Lifts above the product page's sticky Add to cart bar while that bar is showing.
(() => {
  const button = document.querySelector('[data-back-to-top]');
  if (!button) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let ticking = false;

  let last = { show: null, progress: null, lift: null };

  // Read every measurement first, then write only what changed, so scrolling never forces extra layout work.
  const update = () => {
    ticking = false;
    const scrollY = window.scrollY;
    const viewport = window.innerHeight;
    const scrollable = document.documentElement.scrollHeight - viewport;
    const stickyBar = document.querySelector('s-sticky-add[data-visible]');
    const lift = Math.round(stickyBar ? stickyBar.getBoundingClientRect().height : 0);
    const show = scrollY > viewport * 0.8;
    const progress = (scrollable > 0 ? Math.min(1, Math.max(0, scrollY / scrollable)) : 0).toFixed(2);

    if (show !== last.show) {
      last.show = show;
      button.toggleAttribute('data-visible', show);
      button.tabIndex = show ? 0 : -1;
      button.setAttribute('aria-hidden', show ? 'false' : 'true');
    }
    if (show && progress !== last.progress) {
      last.progress = progress;
      button.style.setProperty('--btt-progress', progress);
    }
    if (lift !== last.lift) {
      last.lift = lift;
      button.style.setProperty('--back-to-top-lift', `${lift}px`);
    }
  };

  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  };

  button.addEventListener('click', () => {
    if (!reduceMotion.matches) {
      button.classList.remove('is-launching');
      void button.offsetWidth; // restart the launch animation on repeat clicks
      button.classList.add('is-launching');
    }
    window.scrollTo({ top: 0, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
  });
  button.addEventListener('animationend', (event) => {
    if (event.animationName === 'btt-launch') button.classList.remove('is-launching');
  });

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  update();
})();
